import "./contact_us.css";
const PrivacyPolicy = () => {
return (
    <div className="flex items-center justify-center min-h-screen">
        <div className="col-sm-10 col-md-4 col-xs-10">
            <div className="card-rounded">
                <form action={"https://greeyay.web.app/contact_us"} method={"POST"} className="bg-white space-y-8 shadow border border-gray-300 rounded-2xl p-8">
                    <input type="hidden" name="_token" value="o4YhixI5T7rpy313h49Jr1kOQAVbbfgrmSjTSOeT"/>                
                    <div className="container" style={{marginTop:"0", maxWidth: "100%"}}>
                        <div className="row gx-5 justify-center">
                            <h2 className="text-center" style={{fontWeight: "bolder", marginTop:"0"}}>
                                Contact Us
                            </h2>
                        </div>
                        <div className="row gx-5">
                            <div className="col-md-12">
                                <div>
                                    <h6><label for="email">
                                        Name
                                        <sup className="text-danger-700">*</sup>
                                    </label></h6>
                                    <input type="text" id="name" name="name" maxlength="30" placeholder="Enter your name" required="" className="w-full rounded-lg" style={{borderWidth:"1px", height: "40px", padding: "10px", marginTop:"10px"}}/>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div>
                                    <h6><label for="email">
                                        Email Address
                                        <sup className="text-danger-700">*</sup>
                                    </label></h6>
                                    <input type="email" autocomplete="on" id="email" name="email" placeholder="Enter your email address" required="" className="w-full rounded-lg" style={{borderWidth: "1px", height: "40px", padding: "10px", marginTop:"10px"}}/>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-5">
                            <div className="col-md-12">
                                <h6><label for="email">
                                    Message
                                </label></h6>
                                <textarea name="message" id="message" maxlength="500" placeholder="Enter your message" className="w-full rounded-lg" style={{minHeight: "25vh", padding: "10px", marginTop:"10px"}}/>
                            </div>
                        </div>
                        <div className="row gx-5">
                            <div className="col-md-12">
                                <button type="submit" className="rounded-lg text-white border-transparent w-full" style={{minHeight: "35px", backgroundColor: "#1ac5d9"}}>
                                    <span>Send Email</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
)}
export default PrivacyPolicy;